import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { routes } from './contact.module.routes'
import { ContactComponent } from './components/contact.component'
import { ContactusGateway } from './gateways/contact-gateway'
import { NetworkcontactusGateway } from './gateways/network-contact-gateway'
import { PortalCommonModule } from '../common/portal-common.module'
import { ContactLayoutComponent } from './components/layout/contact-layout.component'
import { MedicareWebsite } from './components/medicare-website/medicare-website.component'
import { JEWebSite } from './components/external-urls/je-website.component'

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RouterModule.forChild(routes),
        PortalCommonModule
    ],
    declarations: [
        ContactComponent,
        ContactLayoutComponent,
        MedicareWebsite,
        JEWebSite
    ],
    providers: [
        { provide: ContactusGateway, useClass: NetworkcontactusGateway }
    ]
})

export class ContactusModule { }
